import { Component, OnInit } from '@angular/core';
import { HttpTokenService } from '../ecare-parent/services/http_token_service';
import { EcareSecurityService } from '../ecare-parent/services/ecare_security_service';
import { ClientService } from '../ecare-parent/services/client.service';
import { UserService } from '../ecare-parent/services/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserServiceService} from '../ecare-parent/user/user-service/user-service.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginErrorText = '';
  loginData: any = {};
  clientList: any = [];
  selectedClient = '';
  viewClientInput = false;

  loginForm: FormGroup;
  loading = false;
  loadingClients = false;
  submitted = false;
  isLoggedIn: boolean;
  hide = true;
  hideClientList = true;
  singleClient = false;
  closeResult: string;
  forgotPasswordForm: any;
  constructor(
    private tokenService: HttpTokenService,
    private securityService: EcareSecurityService,
    private clientService: ClientService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private toastr: ToastrService
    ) {
    this.securityService.isLoggedIn();
    this.forgotPasswordForm = this.formBuilder.group({
      userName: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.securityService.cleanUp();
    this.loginForm = this.formBuilder.group({
        username: ['', Validators.required],
        password: ['', Validators.required]
    });

  }

  login() {
    this.securityService.cleanUp();
    this.loading = true;
    if (this.loginForm.invalid) {
       return;
    }

    this.tokenService.obtainAccessToken(this.loginForm.value)
    .subscribe(
              res => {
                this.loginErrorText = '';
                this.tokenService.saveToken(res);
                this.userService.getUser(this.loginForm.value.username).subscribe(
                  response => {
                    this.loading = false;
                    this.securityService.setUserDetails(response);
                    /*if (response.locked === true) {
                      this.loginErrorText = 'User is locked! Please contact administrator.';
                    } else {
                      this.securityService.setUserDetails(response);
                      const permissions = Object.keys(response.permissions);
                      if (permissions[0] !== 'ELASTIC_CARE' && permissions.length > 0) {
                        console.log('In first condition . . .');
                        this.getClients(response);
                        console.log(response);
                        this.viewClientInput = true;
                        /!* On completion, look for client list and populate.
                        ** Localstorage is not groomedup yet- getting it from instance var. *!/
                        this.clientList = this.securityService.associatedClients;
                        /!* Disabling login fields after successful login and enable clients list. *!/
                        this.switchToSelectClient();
                      } else if (permissions[0] !== 'ELASTIC_CARE') {
                        console.log('In second condition . . . ' + permissions[0]);
                          this.clientService.getClientByClientId(permissions[0]).subscribe(
                            client => {
                              this.securityService.setClientId(client.clientName);
                            }, err => {
                              console.log(err);
                            });
                      } else {*/
                        console.log('In third condition . . .');
                          this.securityService.setClientId('ELASTIC_CARE');
                          this.router.navigateByUrl('/elasticcare/dashboard');
                     /* }
                      if (this.securityService == null) {
                      this.loginErrorText = '';
                      }

                    }*/

                      }, err => {
                        if (err.status === 400) {
                          this.loginErrorText = 'User is not active, please contact administrator!';
                          this.loading = false;
                      }
                    });
              }, err => {
                 // this.toastr.error(err.message, 'Login failed, try with correct username and password');
                 if (err.status === 400) {
                    this.loginErrorText = 'Invalid credential!';
                    this.loading = false;
                  } else {
                    this.loginErrorText = 'Internal Server Error!';
                    this.loading = false;
                }
    });
  }

  private getClients(user: any) {
    this.loadingClients = true;
    const permissions = user.permissions;
    console.log("Number of clients=");
    console.log(Object.keys(permissions).length);
    if(Object.keys(permissions).length === 1){
      console.log("User belongs to single client!");
      this.singleClient=true;
    }else{
      this.singleClient=false;
    }
    for (const clientId in permissions) {
      this.clientService.getClientByClientId(clientId).subscribe(
          client => {
            if (client.clientStatus === 'ACTIVE') {
              this.securityService.addToClientList(client);
              this.securityService.setClientId(client);

              if(this.singleClient){
                this.securityService.setClientId(client.id);
                this.router.navigateByUrl('/elasticcare/dashboard');
              }
            }
          }, err => {
            console.log(err);
          });
    }
    this.loadingClients = false;
  }

  switchToSelectClient() {
    this.loginForm.get('username').disable();
    this.loginForm.get('password').disable();
    this.hideClientList = false;
  }

  clientSelectEvent(event: any) {
      // Look for better way
      const client = this.clientList.find(ob => ob['clientName'] === event.target.value);
    this.securityService.setClientId(client.id);
    this.router.navigateByUrl('/elasticcare/dashboard');
  }

    cancelLogin() {
      this.securityService.cleanUp();
        this.loginForm.get('username').enable();
        this.loginForm.get('password').enable();
        this.hideClientList = true;
    }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  forgotPassword() {
    this.loading = true;
    this.userService.resetPassword(this.forgotPasswordForm.value.userName)
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Check your mail for new Password');
            this.modalService.dismissAll();
            this.securityService.logout();
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.loading = false;
          // this.toastr.error('', 'Please try again');
        });
  }

}
